import React, {useEffect} from 'react';

export const JobSubmitSuccess = () => {
    useEffect(() => {
        window.location.href = '/v2/';
    }, []);

    return <span />;
};
